var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-3"},_vm._l((_vm.reports),function(report){return _c('div',{staticClass:"d-inline-block",domProps:{"innerHTML":_vm._s(report.iframe)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }